import { render, staticRenderFns } from "./FormCoach.vue?vue&type=template&id=38ba0a2e&scoped=true"
import script from "./FormCoach.vue?vue&type=script&lang=js"
export * from "./FormCoach.vue?vue&type=script&lang=js"
import style0 from "./FormCoach.vue?vue&type=style&index=0&id=38ba0a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba0a2e",
  null
  
)

export default component.exports